/**
 * Check if the key is of the type specified
 *
 * @param keyToMatch Key to check
 * @param keyTypes Type to check
 * @param keysMap Map of keys
 *
 * @returns Return true if the key is of the type specified
 */
export function checkMatch(keyToMatch: string, keysMap: Record<string, unknown>): boolean {
    return keyToMatch in keysMap;
}
